<template>
  <DataGetter
    @dataAvailable="
      data => {
        categories = data?.metaData?.categories
      }
    "
    contentId="categories"
  />
  <DataGetter
    @dataAvailable="
      data => {
        appInfo = data?.metaData
      }
    "
    contentId="appInfo"
  />
  <form @submit.prevent="submitForm">
    <div class="grid grid-cols-1 md:grid-cols-5 gap-4">
      <!-- Section Informations générales -->
      <div class="md:col-span-3 border bg-white rounded-3xl p-4">
        <h1 class="text-lg font-bold title-color">Informations Générales</h1>
        <div class="py-2"></div>
        <InputComponent
          required
          label="Nom du produit"
          placeHolder="T-Shirt"
          v-model="formData.name"
        />
        <InputComponent
          required
          label="Description du produit"
          type="textarea"
          placeHolder="Ajoutez une description"
          v-model="formData.description"
        />
      </div>

      <!-- Section Media -->
      <div class="md:col-span-2 border bg-white rounded-3xl p-4 flex flex-col">
        <h1 class="text-lg font-bold title-color">Media du produit</h1>
        <div class="py-2"></div>
        <div
          class="h-full border-2 border-dashed rounded-3xl p-4 flex flex-col relative"
        >
          <div class="text-center top-1 absolute w-full pointer-events-none">
            Image Principale
          </div>
          <div class="w-full h-full py-5">
            <div class="flex justify-center gap-3 h-full">
              <img
                v-if="formData.image"
                class="w-1/2 md:w-1/3 h-full object-contain rounded-2xl bg-slate-100 border overflow-hidden"
                :src="formData.image"
                alt=""
              />
            </div>
          </div>
          <div class="py-2"></div>
          <div class="w-full flex justify-center mt-auto">
            <div>
              <FileUploader
                :acceptedFilesTypes="['image/png', 'image/jpeg']"
                @onFileChanged="
                  (id, name, url) => principalImagePicked(id, name, url)
                "
              >
                <div
                  class="bg-primary-100 border-2 border-primary px-4 py-2 rounded-2xl"
                >
                  {{
                    formData.image ? "Change d'image" : 'Sélectionner une image'
                  }}
                </div>
              </FileUploader>
            </div>
          </div>
        </div>
        <div class="py-2"></div>
        <div
          class="h-full border-2 border-dashed rounded-3xl p-4 flex flex-col relative"
        >
          <div class="text-center top-1 absolute w-full pointer-events-none">
            Images Secondaires
          </div>
          <div class="w-full overflow-auto h-full py-5">
            <div class="flex min-w-max gap-3 h-full">
              <div
                class="relative w-[10rem] h-full group"
                v-for="(image, i) in formData.images"
                :key="i"
              >
                <img
                  class="w-full h-full object-contain rounded-2xl bg-slate-100 border overflow-hidden"
                  :src="image"
                  alt=""
                />
                <!-- Croix de suppression au survol -->
                <div
                  class="hidden group-hover:flex absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 text-white bg-red-500 rounded-full w-4 h-4 items-center justify-center cursor-pointer"
                  @click="removeImage(i)"
                >
                  <span class="text-xs">×</span>
                </div>
              </div>
            </div>
          </div>
          <div class="py-2"></div>
          <div class="w-full flex justify-center mt-auto">
            <div>
              <FileUploader
                :acceptedFilesTypes="['image/png', 'image/jpeg']"
                @onFileChanged="
                  (id, name, url) => newFileSelected(id, name, url)
                "
                :key="filePikerId"
              >
                <div
                  class="bg-primary-100 border-2 border-primary px-4 py-2 rounded-2xl"
                >
                  Ajouter plus d'images
                </div>
              </FileUploader>
            </div>
          </div>
        </div>
      </div>

      <!-- Section Pricing -->
      <div class="md:col-span-3 border bg-white rounded-3xl p-4">
        <h1 class="text-lg font-bold title-color">Pricing</h1>
        <div class="py-2"></div>
        <InputComponent
          required
          label="Prix"
          type="number"
          suffix="XOF"
          placeHolder="5000"
          v-model="formData.price"
        />
        <!-- <InputComponent
          label="Réduction"
          type="number"
          suffix="%"
          min="0"
          max="100"
          placeHolder="Appliquer une réduction"
          v-model="formData.discount"
        /> -->
      </div>

      <!-- Section Catégorie -->
      <div class="md:col-span-2 row-span-2 border bg-white rounded-3xl p-4">
        <h1 class="text-lg font-bold title-color">
          Catégorie & Sous catégorie
        </h1>
        <div class="py-2"></div>
        <InputComponent
          label="Catégorie du produit"
          type="select"
          :options="
            categories.map(option => {
              return `${option.name}`
            })
          "
          required
          v-model="formData.category"
        />

        <div class="py-2"></div>
        <InputComponent
          v-if="subcategories(formData.category)[0]"
          label="Sous Catégorie"
          type="select"
          :options="
            subcategories(formData.category).map(option => {
              return `${option.name}`
            })
          "
          required
          v-model="formData.subcategory"
        />
      </div>

      <!-- Section Stock -->
      <div
        class="md:col-span-3 border bg-white rounded-3xl p-4"
        v-if="formData.categoryId !== 'digital'"
      >
        <h1 class="text-lg font-bold title-color">En Stock</h1>
        <div class="py-2"></div>
        <InputComponent
          required
          label="Quantité Disponible"
          type="number"
          min="0"
          max="9999999"
          placeHolder="200"
          v-model="formData.quantity"
        />
      </div>

      <div
        class="md:col-span-5 grid grid-cols-1 gap-4 md:grid-cols-3"
        v-if="formData.categoryId !== 'digital'"
      >
        <div
          class="w-full h-full border bg-white rounded-3xl p-4 flex flex-col"
        >
          <h1 class="text-lg font-bold title-color">Couleurs (Facultatif)</h1>
          <div class="mt-4 relative h-full">
            <div
              class="w-full overflow-auto h-full py-5"
              v-if="formData.color?.length !== 0"
            >
              <div class="flex min-w-max gap-3 h-full">
                <div
                  class="relative w-[8rem] h-[8rem] group rounded-2xl p-[0.5rem]"
                  v-for="(color, i) in formData.color"
                  :key="i"
                  :style="{ backgroundColor: color.hexCode }"
                >
                  <img
                    v-if="color.image"
                    class="w-full h-[6rem] rounded-2xl object-contain bg-slate-100 border overflow-hidden"
                    :src="color.image"
                    alt=""
                  />
                  <div
                    class="w-full bottom-0 text-center invert brightness-200"
                  >
                    <span :style="{ color: color.hexCode }">
                      {{ color.name }}
                    </span>
                  </div>
                  <!-- Croix de suppression au survol -->
                  <div
                    class="hidden group-hover:flex absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 text-white bg-red-500 rounded-full w-4 h-4 items-center justify-center cursor-pointer"
                    @click="removeColor(i)"
                  >
                    <span class="text-xs">×</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="h-full flex items-center justify-center">
              <div>Aucune couleur choisie</div>
            </div>
          </div>
          <div class="py-2 mt-auto"></div>
          <div class="flex justify-center">
            <div
              tabindex="1"
              @click="addColor"
              class="cursor-pointer ripple bg-primary-100 border-2 border-primary px-4 py-2 rounded-2xl inline-block"
            >
              Ajouter une couleur
            </div>
          </div>
        </div>
        <div class="w-full h-full border bg-white rounded-3xl p-4">
          <h1 class="text-lg font-bold title-color">
            Tailles disponibles (Facultatif)
          </h1>
          <div class="mt-4 relative">
            <div
              class="w-full -ml-4 space-y-4 space-x-4"
              v-if="availableSizes?.length !== 0"
            >
              <div
                class="cursor-pointer select-none ml-4 relative w-max whitespace-nowrap border px-4 py-2 x rounded-2xl inline-block"
                v-for="(size, i) in availableSizes"
                :key="i"
                @click="toggleSize(size)"
                :class="{
                  'shadow-lg border-primary': (formData.size || []).includes(
                    size,
                  ),
                }"
              >
                <div class="w-full bottom-0 text-center invert brightness-200">
                  {{ size }}
                </div>
              </div>
            </div>
            <div
              v-else
              class="h-full flex items-center justify-center text-center px-5 py-12"
            >
              <div v-if="!formData.category">
                Sélectionnez une catégorie pour avoir les tailles disponibles
              </div>
              <div
                v-else-if="
                  subcategories(formData.category)[0] && !formData.subcategory
                "
              >
                Sélectionnez une Sous-Catégorie pour avoir les tailles
                disponibles
              </div>
              <div v-else>Aucune taille disponible pour ce type de produit</div>
            </div>
          </div>
        </div>
        <div
          class="w-full h-full flex flex-col border bg-white rounded-3xl p-4"
        >
          <h1 class="text-lg font-bold title-color">Poids (Facultatif)</h1>
          <div class="mt-4 relative">
            <div
              class="w-full -ml-4 space-y-4 space-x-4"
              v-if="
                Array.isArray(formData.weight) && formData.weight?.length !== 0
              "
            >
              <div
                class="cursor-pointer select-none ml-4 relative w-max whitespace-nowrap border px-4 py-2 rounded-2xl inline-block group"
                v-for="(weight, i) in formData.weight"
                :key="i"
              >
                <div class="w-full bottom-0 text-center invert brightness-200">
                  {{ weight.value }}&nbsp;{{ weight.unitId }}
                </div>
                <div
                  class="hidden group-hover:flex absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 text-white bg-red-500 rounded-full w-4 h-4 items-center justify-center cursor-pointer"
                  @click="removeWeight(i)"
                >
                  <span class="text-xs">×</span>
                </div>
              </div>
            </div>
            <div
              v-else
              class="h-full flex items-center justify-center text-center py-12"
            >
              <div>Vous n'avez ajouté aucun poids</div>
            </div>
          </div>
          <div class="flex justify-center mt-auto">
            <div
              tabindex="1"
              @click="addWeight"
              class="cursor-pointer ripple bg-primary-100 border-2 border-primary px-4 py-2 rounded-2xl inline-block"
            >
              Ajouter un poids
            </div>
          </div>
        </div>
      </div>

      <div
        class="md:col-span-5 border bg-white rounded-3xl p-4"
        v-if="formData.categoryId !== 'digital'"
      >
        <h1 class="text-lg font-bold title-color">Details spécifics</h1>
        <div class="py-2"></div>
        <div class="grid grid-cols-3 gap-x-4">
          <InputComponent
            required
            label="Marque"
            type="text"
            placeHolder="La marque du produit"
            v-model="formData.brand"
          />
          <InputComponent
            required
            label="Matériel"
            type="text"
            placeHolder="Matériel de construction du produit"
            v-model="formData.material"
          />
          <InputComponent
            required
            label="Etat"
            type="text"
            placeHolder="Neuv, Deuxième main, ..."
            v-model="formData.condition"
          />
        </div>
      </div>

      <div class="md:col-span-5 border bg-white rounded-3xl p-4" v-else>
        <h1 class="text-lg font-bold title-color">Téléversez le contenu</h1>
        <div class="py-2"></div>
        <div class="grid gap-x-4">
          <InputComponent
            label="Fichier"
            type="file"
            placeHolder="Sélectionner un fichier"
            alreadyExistPlaceHolder="Changez le fichier"
            v-model="formData.downloadLink"
          />
        </div>
      </div>
    </div>

    <div class="py-4"></div>
    <div class="flex justify-center">
      <button type="submit" class="buttonComponent">
        {{ isEditing ? 'Mettre à jour' : 'Ajouter' }}
      </button>
    </div>
    <div class="pb-12"></div>
  </form>
</template>

<script>
import { defineComponent } from 'vue'
import InputComponent from '../utils/InputComponent.vue'
import FileUploader from '../utils/FileUploader.vue'
import DataGetter from '../utils/DataGetter.vue'
import sizeConfigs from '@/utils/raws/sizeConfigs.json'
import weightUnits from '@/utils/raws/weightUnits.json'

export default defineComponent({
  name: 'ProductForm',
  components: {
    InputComponent,
    FileUploader,
    DataGetter,
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({
        name: '',
        description: '',
        price: null,
        category: '',
        isDigitalProduct: false,
        downloadLink: '',
        subcategory: '',
        quantity: null,
        color: [],
        images: [],
        size: [],
        weight: [],
      }),
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: { ...this.initialData },
      filePikerId: 'test',
      categories: [],
      appInfo: {},
      weightUnits: weightUnits,
      selectedSizeType: {},
    }
  },
  methods: {
    findCategoryByName(categoryName) {
      return this.categories.find(category => category.name == categoryName)
    },
    subcategories(categoryName) {
      const categoryFound = this.findCategoryByName(categoryName)
      return categoryFound?.subcategories || []
    },
    findsubcategorybyName(categoryName, subcategoryName) {
      const subcategories = this.subcategories(categoryName)
      return subcategories.find(sub => sub.name == subcategoryName)
    },
    principalImagePicked(id, name, url) {
      this.formData.image = url
    },
    newFileSelected(id, name, url) {
      this.formData.images.push(url)
      this.filePikerId = `${Date.now()}`
    },
    openColorPicker() {
      this.$refs.colorPicker.click()
    },
    removeColor(index) {
      this.formData.color.splice(index, 1)
    },
    removeImage(index) {
      this.formData.images.splice(index, 1)
    },
    removeWeight(index) {
      this.formData.weight.splice(index, 1)
    },
    async addColor() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: 'Ajouter une nouvelle couleur',
          // subTitle: 'Sélectionnez la couleur et sélectionner une image qui y',
          formFields: [
            {
              type: 'text',
              propertyName: 'name',
              label: 'Nom',
              defaultValue: 'Jaune',
              required: true,
            },
            {
              type: 'color',
              propertyName: 'hexCode',
              label: '',
              defaultValue: '#ffff00',
              class:
                '[&_.inputContainer]:!overflow-hidden [&_.inputContainer]:!border-none [&_input]:!scale-[1.5]  [&_input]:!rounded-[2rem] [&_input]:!overflow-hidden ',
              required: true,
            },
            {
              type: 'file',
              propertyName: 'image',
              label: 'Image illustrative',
              defaultValue: '',
              class: '',
              required: false,
            },
          ],
          successText: 'Ajouter',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      const newColor = {
        name: prompt.data.name,
        hexCode: prompt.data.hexCode,
        image: prompt.data.image,
      }
      console.log(newColor)
      if (!Array.isArray(this.formData.color)) this.formData.color = []
      this.formData.color.push(newColor)
    },
    async addWeight() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: 'Ajouter un poids',
          // subTitle: 'Sélectionnez la couleur et sélectionner une image qui y',
          formFields: [
            {
              type: 'number',
              propertyName: 'value',
              label: 'Valeur',
              defaultValue: '',
              required: true,
            },
            {
              type: 'select',
              propertyName: 'unit',
              label: 'Image illustrative',
              options: this.weightUnits.map(unit => unit.name),
              defaultValue: '',
              class: '',
              required: true,
            },
          ],
          successText: 'Ajouter',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      const matchingUnit = this.weightUnits.find(
        unit => unit.name == prompt.data.unit,
      )
      const newWeight = {
        value: prompt.data.value,
        unitName: matchingUnit.name,
        unitId: matchingUnit.id,
      }
      console.log(newWeight)
      if (!Array.isArray(this.formData.weight)) this.formData.weight = []
      this.formData.weight.push(newWeight)
    },
    toggleSize(size) {
      if (!Array.isArray(this.formData.size)) this.formData.size = []
      const foundSizeIndex = this.formData.size.indexOf(size)
      if (foundSizeIndex === -1) this.formData.size.push(size)
      else this.formData.size.splice(foundSizeIndex, 1)
    },
    submitForm() {
      const data = {
        ...this.formData,
        isDigitalProduct: this.formData.categoryId == 'digital',
        // categoryId: this.findCategoryByName(this.formData.category)?.id || '',
        // subcategoryId:
        //   this.findsubcategorybyName(
        //     this.formData.category,
        //     this.formData.subcategory,
        //   )?.id || '',
      }
      if (data.isDigitalProduct) data.quantity = 9999999999
      this.$emit('productSubmitted', data)
    },
  },
  computed: {
    availableSizeTypes() {
      if (!this.formData.category || !this.formData.subcategory) return []
      const categoryId =
        this.findCategoryByName(this.formData.category)?.id || ''
      const subcategoryId =
        this.findsubcategorybyName(
          this.formData.category,
          this.formData.subcategory,
        )?.id || ''
      const allSizes = this.appInfo?.sizes || []
      const res = allSizes.filter(size => {
        if (size.categoriesIds.includes(categoryId)) return true
        if (size.categoriesIds.includes(subcategoryId)) return true
        return false
      })
      return res
    },
    availableSizes() {
      return this.selectedSizeType?.size || []
    },
  },
  watch: {
    availableSizeTypes(newVal) {
      if (newVal.length == 1) this.selectedSizeType = newVal[0]
      else this.selectedSizeType = {}
    },
    ['formData.category']() {
      this.formData.categoryId =
        this.findCategoryByName(this.formData.category)?.id || ''
      this.formData.subcategory = ''
      this.formData.size = []
    },
    ['formData.subcategory']() {
      this.formData.subcategoryId =
        this.findsubcategorybyName(
          this.formData.category,
          this.formData.subcategory,
        )?.id || ''
      this.formData.size = []
    },
  },
})
</script>

<style scoped></style>
